//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { throws } from "assert";
import InvoiceInfo from "components/invoice-info/invoice-info";
import { mapState } from "vuex";
export default {
  data() {
    return {
      selectedTab: 0,
      refreshing: false, //下拉刷新状态
      loading: false, //上拉加载状态
      finished: false, // 加载完毕
      isHistory: false,
      disabled: false,
      loop: false,
      autoPlay: false,
      showDots: false,
      selectedList: [],
      submitLoading: false, //提交按钮加载状态
      tabLabels: [
        {
          value: 0,
          label: "待开发票"
        },
        {
          value: 1,
          label: "已开发票"
        }
      ],
      searchData: {
        invoiceStatus: "0",
        patcode: this.$route.query.patcode,
        patname: this.$route.query.patname,
        rqq: this.$route.query.rqq,
        rqz: this.$route.query.rqz,
        cxtype: this.$route.query.cxtype,
        pageNum: 0,
        pageSize: 10
      },
      totalNum: 1,
      historyNotList: [{}, {}, {}], // 已开发票列表数据
      historyList: [], // 待开发票列表数据
      showNoMore: false
    };
  },
  mounted() {
    // this.loadBillData(1, 0);
  },
  computed: {
    ...mapState("invoice", ["itemBillInfo"])
  },
  methods: {
    // 合并开具电子发票
    submitClick() {
      if (this.selectedList.length === 0) {
        this.$dialog.alert({
          message: "请选择要开具的订单"
        });
        return false;
      } else if (this.selectedList.length > 1){
        this.$dialog.alert({
          message: "不允许合并开票"
        });
        return false;
      }
      let tradeNo = "";
      let deptId = "";
      let custName = "";
      let cxtype = this.$route.query.cxtype;
      let showKplx = true;
      let price = 0;
      this.selectedList.forEach((v, i) => {
        price += Number(v.totalAmout);
        if (i > 0) {
          tradeNo += "," + v.id;
        } else {
          tradeNo += v.id;
          deptId = v.deptId;
          custName = v.srcStrName;
          if(v.settType === '1'){
            showKplx = false;
          }
        }
      })
      //deptId="JNBNYTZYYY";
      let chargeList=this.selectedList;
      this.submitLoading = true;
      this.$router.push({
        path: "/InvoicePreview",
        query: {
          tradeNo,
          deptId,
          price,
          showKplx,
          custName,
          cxtype,
          chargeList
        }
      });
    },
    // 切换tab触发
    async changeTabs(type) {
      this.historyList = [];
      await this.loadBillData(1, type);
    },
    // 加载账单数据
    loadBillData(pageIndex, type) {
      return new Promise((resolve, rejected) => {
        this.finished = false;
        this.searchData.pageNum = pageIndex;
        this.searchData.invoiceStatus = type;
        if(type == 0 && this.itemBillInfo.list){
          console.log(this.itemBillInfo.list);
          this.historyList = this.historyList.concat(this.itemBillInfo.list);
          this.totalNum = this.itemBillInfo.total;
          if (this.historyList.length < this.itemBillInfo.total) {
            this.loading = false;
          } else {
            this.loading = true;
            this.finished = true;
          }
          resolve();
          this.itemBillInfo.list = null
        }else{
          this.$request({
            url: "/erpQuery/queryOrder",
            data: this.searchData
          }).then(res => {
            // 没有数据
            if (!res) {
              return;
            }
            this.historyList = this.historyList.concat(res.list);
            this.totalNum = res.total;
            if (this.historyList.length < res.total) {
              this.loading = false;
            } else {
              this.loading = true;
              this.finished = true;
            }
            resolve();
          });
        }
      });
    },
    // 下拉刷新
    async onPullingDown(listType) {
      this.historyList = [];
      await this.loadBillData(1, listType);
      this.refreshing = false;
    },
    // 滚动条与底部距离小于 offset 时触发
    async onPullingUp(listType) {
      let pageIndex = this.searchData.pageNum + 1;
      if (this.historyList.length < this.totalNum) {
        await this.loadBillData(pageIndex, listType);
      }
    }
  },
  components: {
    InvoiceInfo
  }
};



// WEBPACK FOOTER //
// ./src/pages/invoice-list/invoice-list.vue